<template>
<div>
    <!-- modal -->
    <b-modal id="nationalTrademarkNoteFormModal" ref="nationalTrademarkNoteFormModal" centered size="lg" no-close-on-backdrop :title=" $t('nationalTrademarkNote.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules" tag="form">
            <b-row>
                <b-col class="col-md-12">
                    <label for="nationalTrademark-note-date-input">{{ $t('nationalTrademarkNote.date') }}</label>
                    <validation-provider #default="{ errors }" :name="$t('nationalTrademarkNote.date')" rules="required">
                        <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" id="date" v-model="date" :defaultDate="null" reset-button class="mb-1" size="sm" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :placeholder="$t('nationalTrademarkNote.date')" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" :state="errors.length > 0 ? false : null" />
                        <small class="text-danger">{{ errors[0] }}</small><small class="text-danger">{{errors[0]}}</small>
                    </validation-provider>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-12">
                    <b-form>
                        <label for="nationalTrademark-note-employee-input">{{ $t('nationalTrademarkNote.employee') }}</label>
                        <b-form-select v-model="employeeSelect" value-field="id" text-field="name" size="sm" :options="employeeOption" />
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-md-12">
                    <label for="textarea-default">{{ $t('nationalTrademarkNote.note') }}</label>
                    <validation-provider #default="{ errors }" :name="$t('nationalTrademarkNote.note')" rules="required">
                        <b-form-textarea id="textarea-default" :placeholder="$t('nationalTrademarkNote.note')" size="sm" v-model="note" rows="2" maxlength="500" :state="errors.length > 0 ? false : null" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        nationalTrademarkId: Number,
        getNationalTrademarkNoteList: {
            type: Function
        },
        getNationalTrademarkList: {
            type: Function
        },
    },
    data() {
        return {
            id: 0,
            note: '',
            date: null,
            employeeOption: [],
            employeeSelect: 0,
        }
    },
    methods: {
        showInfo(id, nationalTrademarkId) {
            this.$refs['nationalTrademarkNoteFormModal'].show()
            this.id = id
            this.nationalTrademarkId = nationalTrademarkId
            const data = {
                id: this.id
            }
            const controller = {
                name: 'NationalTrademarkNote'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.note = response.data.nationalTrademarkNote.note
                    this.date = response.data.nationalTrademarkNote.date
                    if (response.data.nationalTrademarkNote.employeeId > 0) {
                        this.employeeSelect = response.data.nationalTrademarkNote.employeeId;
                    } else {
                        this.employeeSelect = localStorage.getItem('EmployeeId');
                    }
                    this.employeeOption = response.data.employeeList
                    this.employeeOption.splice(0, 0, this.$nullSelected())
                } else {
                    this.$bvModal.hide('nationalTrademarkNoteFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                nationalTrademarkId: this.nationalTrademarkId,
                note: this.note,
                date: this.date,
                employeeId: this.employeeSelect
            }
            const controller = {
                name: 'NationalTrademarkNote'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('nationalTrademarkNoteFormModal')
                            this.getNationalTrademarkNoteList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
